///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, ElementRef, HostListener, OnDestroy, OnInit } from '@angular/core';
import { GtthHistoryService } from '../../../logical-topology/engine/history-service';
import { ActivatedRoute } from '@angular/router';
import { AbstractInteractiveWindow } from '../../abstract-interactive-window';
import { ProjectInteractiveWindowsPopupService } from '../../project-interactive-windows-popup.service';
import { PARAM_BBOX } from '../../../../shared/constants/url-params.constants';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'winde-config-rings-error-report',
    templateUrl: './config-rings-error-report.component.html',
    styleUrls: ['../../project-windows.scss'],
    standalone: false
})
export class GtthConfigRingsErrorReportComponent extends AbstractInteractiveWindow implements OnDestroy {
    public modalTitle: string;

    constructor(
        private readonly elementRef: ElementRef,
        public dialogRef: MatDialogRef<GtthConfigRingsErrorReportComponent>,
        public historyService: GtthHistoryService
    ) {
        super(elementRef);
    }

    ngOnDestroy() {
        this.historyService.autoConfigRingsErrorNodes = undefined;
    }

    closeModal() {
        this.dialogRef.close('cancel');
    }

    @HostListener('document:keydown', ['$event'])
    onKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape' && !this.historyService.hasSearchMarkers()) {
            this.closeModal();
        }
    }

    designRequired(): boolean {
        return false;
    }

    isRestorable(): boolean {
        return false;
    }
}

@Component({
    selector: 'winde-config-rings-error-report-popup',
    template: '',
    standalone: false
})
export class GtthConfigRingsErrorReportPopupComponent implements OnInit {
    constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly interactiveWindowsPopupService: ProjectInteractiveWindowsPopupService
    ) {}

    ngOnInit() {
        let bboxParams;
        if (this.activatedRoute.snapshot.queryParamMap.has(PARAM_BBOX)) {
            bboxParams = this.activatedRoute.snapshot.queryParamMap
                .get(PARAM_BBOX)
                .split(',')
                .map((value) => parseFloat(value));
        }
        const routerPath = this.activatedRoute.routeConfig.path;
        this.interactiveWindowsPopupService.openInteractiveWindow(
            GtthConfigRingsErrorReportComponent,
            ProjectInteractiveWindowsPopupService.CONFIG_RINGS_ERROR,
            routerPath,
            bboxParams,
            this.activatedRoute.snapshot.paramMap.get('title')
        );
    }
}
